import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';

export class RemoveProductRecipeLinkingService extends HttpServiceBase {

  handle = (input: RemoveProductRecipeLinkingServiceInput): Promise<Result<RemoveProductRecipeLinkingServiceOutput> | null> => {
    const promise = this.http.post<Result<RemoveProductRecipeLinkingServiceOutput>, RemoveProductRecipeLinkingServiceInput>(
      `${this.baseUrlSislogApi}/point-of-sale/product-recipe-linking-deletion?apiKey=${this.getSislogApiKey()}`,
      input);
    return promise;
  }
}

export class RemoveProductRecipeLinkingServiceInput {
  productRecipeLinkingRequestId: number;
  userId?: number | null;
  reason: string;
  processPrescriptionState: boolean;
}

export class RemoveProductRecipeLinkingServiceOutput {
  result: boolean;
}